module.exports = __webpack_public_path__ + "pc/img/swiper_logo_03.9c88966d.png";